module.exports = __webpack_public_path__ + "media/images/social-icons/twitter-f7b7467d629358ca1fff216b2bdb30cc.svg";